import React from 'react';
import c from 'classnames';
import Immutable from 'immutable';

import { ImageFromField } from '@uncinc/react-drupal-core';

import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
  SCREEN_WIDE,
} from '../../../../config/constants';

import './style.scss';

export interface WebformRadiosWithImageImageProps {
  title?: string;
  alt: string;
  className?: string;
  src: string;
  styles: Record<string, string>;
}

const WebformRadiosWithImageImage: React.FC<WebformRadiosWithImageImageProps> = ({
  title,
  alt,
  className,
  src,
  styles,
}) => (
  <div className={c('WebformRadiosWithImageImage', className)}>
    <ImageFromField
      className="WebformRadiosWithImageImage__image"
      src={src}
      field={Immutable.fromJS({ title, alt, styles })}
      imageStyles={Immutable.Map({
        [SCREEN_MOBILE]: 'ratio_3_2_sm',
        [SCREEN_TABLET]: 'ratio_3_2_md',
        [SCREEN_NORMAL]: 'ratio_3_2_sm',
        [SCREEN_WIDE]: 'ratio_3_2_sm',
      })}
      // Lazy loading seems to break here.
      includeWebP={false}
    />
  </div>
);

export default WebformRadiosWithImageImage;
